/* eslint-disable no-shadow */
export enum FilterParams {
  All = 'All',
  Active = 'Active',
  Completed = 'Completed',
}
